// extracted by mini-css-extract-plugin
export default {"editableValueHolder":"editableField_editableValueHolder__ch4Lr","editableBtn":"editableField_editableBtn__y-Xih"};